import * as React from 'react';

export default (props:any) => (
    <svg
        width="14px"
        height="22px"
        viewBox="0 0 14 22"
        {...props}
    >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-5, -1)">
                <path
                    d="M16,1 L8,1 C6.34,1 5,2.34 5,4 L5,20 C5,21.66 6.34,23 8,23 L16,23 C17.66,23 19,21.66 19,20 L19,4 C19,2.34 17.66,1 16,1 Z M14,21 L10,21 L10,20 L14,20 L14,21 Z M17.25,18 L6.75,18 L6.75,4 L17.25,4 L17.25,18 Z"
                    fill="currentColor"
                    fillRule="nonzero"
                />
            </g>
        </g>
    </svg>
)
